@import '../../../styles/base';
@import 'layoutMixins';

.static-form__css-grid.view-default {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;

  .block {
    grid-column: span 6;
    margin-bottom: 0.5rem;
    width: 100%;
  }
}

.standard-side-panel {
  @include media-breakpoint-up(lg) {
    .static-form__css-grid.view-default {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: repeat(5, auto) auto [gimmicks] auto [spm];
      align-content: start;

      .block {
        grid-column: span 6;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
      }

      #TabContainer.block,
      #TabContainerForQuote.block {
        grid-row-start: spm;
        grid-column: 1 / span 12;
        margin-top: 0.25rem;
      }

      #Gimmicks {
        grid-column: 1 / span 12;
        grid-row-start: gimmicks;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .block {
          flex-grow: 1;
          width: 45%;
        }
      }

      @include media-breakpoint-up(xxl) {
        #Gimmicks {
          .block {
            width: 30%;
          }
        }
      }
    }
  }
}

/** ********* PRODUCTS BELOW ****************  **/

@include autocall(AthenaApollonOxygen);
@include athenaBearish(AthenaBearish);
@include autocall(DailyAccrual);
@include autocall(Phoenix);
@include autocall(PhoenixCombo);
@include autocall(PhoenixDouble);
@include autocall(PhoenixDoubleUp);
@include autocall(PhoenixPlus);
@include autocall(PhoenixWithGuaranteedCoupons);
@include autocall(TriggerBarrierDiscountCertificate);
@include autocall(TriggerBarrierReverseConvertible);
@include autocall(CallableReverseConvertible);
@include autocall(SuperTracker);

@include asianAutocall(KIKO);
@include asianAutocall(Sharkfin);
@include asianAutocall(FixedCouponNote);
@include asianAutocall(FixedCouponNoteWithDailyKnockOutSwap);
@include asianAutocall(RangeAccrual);
@include asianAutocall(ApollonStepdownTwinWin);
@include asianAutocall(ApollonStepdownTwinWinWithDailyKnockOut);
@include asianAutocall(PhoenixKorea);

@include athena(AthenaApollon);
@include athena(DailyAthena);

@include reverseConvertible(BarrierDiscountCertificate);
@include reverseConvertible(BarrierReverseConvertible);
@include reverseConvertible(DiscountCertificate);
@include reverseConvertible(StandardReverseConvertible);
@include reverseConvertible(BarrierReverseWithConditionalCoupons);
@include asianReverseConvertible(FixedCouponNoteWithDailyKnockOutNote);
@include asianReverseConvertible(RangeAccrualWithDailyKnockOut);

@include phoenixBearish(PhoenixBearish);
@include phoenixZCBearish(PhoenixZCBearish);

/**     ** PARTICIPATIONS **      */

@include callPutVanilla(CallPutVanilla);
@include airbag(Airbag);
@include outperformer(OutPerformer);
@include callspreadputspread(CallSpreadPutSpread);
@include bonusCertificate(BonusCertificate);
@include bonusCertificate(CappedBonusCertificate);
@include twinWin(TwinWin);

/**     ** FOREX **      */

@include dcn(Dcn);

@include fixedRateNote(IssuerCallableFixedRateNote);
@include fixedRateNote(IssuerCallableZCFixedRateNote);
@include floatingRateNote(CappedFlooredFloatingRateNote);
@include floatingRateNote(AutocallableCappedFlooredFloatingRateNote);
@include floatingRateNote(IssuerCallableCappedFlooredFloatingRateNote);
@include floatingRateNoteRangeAccrual(RangeAccrualOnRates);
@include floatingRateNoteRangeAccrual(RangeAccrualNoteOnFX);

@include callPutBasketVsCallsPuts(CallPutBasketVsCallsPuts);
@include forwardQuanto(ForwardQuanto);
@include forwardQuanto(CallPutOnWorstBest);

/**     ** STAR STREET **      */
@include asianSingleRangeAccrual(BulletSingleRangeAccrualOnRates);
@include asianSingleRangeAccrual(CallableSingleRangeAccrualOnRates);
@include asianDualRangeAccrual(BulletDualRangeAccrualOnRates);
@include asianDualRangeAccrual(CallableDualRangeAccrualOnRates);

@include asianSingleRangeAccrual(BulletSingleRangeAccrualOnFX);
@include asianSingleRangeAccrual(CallableSingleRangeAccrualOnFX);
@include asianDualRangeAccrual(CallableDualRangeAccrualOnFX);
@include asianDualRangeAccrual(BulletDualRangeAccrualOnFX);
@include asianAutocall(AutocallableRangeAccrualOnRates);
@include asianDefaultableRangeAccrual(DefaultableRangeAccrualOnRates);
@include asianAutocall(DefaultableRangeAccrualOnFX);

@include asianSingleRangeAccrual(PeggedDigital);
@include asianAutocall(CallableZCDigital);
@include asianCallableFRN(CallableCappedFlooredInverseFloater);

@include otcHedge(Fva);

/**     ** DLP **      */
@include leveragedProducts(MiniFutureUnlimited);
@include leveragedProducts(MiniFutureLimited);
@include leveragedProducts(PlainVanillaWarrant);
@include leveragedProducts(CappedWarrant);
@include retailFlowProducts(DiscountCertificateFlow);
@include retailFlowProducts(BonusCertificateFlow);
@include retailFlowProducts(CapitalGuaranteedCertificate);
@include retailFlowProducts(CappedBonusCertificateFlow);
